module.exports = __webpack_public_path__ + "img/Title-CN.0cc25662.png";